import React from 'react';
import { PhoneIcon, BoltIcon, ShieldCheckIcon, UserGroupIcon } from '@heroicons/react/24/outline';

const highlights = [
  {
    icon: PhoneIcon,
    title: 'Dedicated support',
    description: 'A named account manager who knows your business inside and out.',
  },
  {
    icon: BoltIcon,
    title: 'Custom integrations',
    description: 'API access, custom webhooks, and white-label capabilities.',
  },
  {
    icon: ShieldCheckIcon,
    title: 'SLA guarantee',
    description: 'Enterprise-grade uptime and priority incident response.',
  },
  {
    icon: UserGroupIcon,
    title: 'Team management',
    description: 'Unlimited seats with role-based permissions and audit logs.',
  },
];

const EnterpriseCTASection = () => {
  return (
    <section className="py-16 md:py-24">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative rounded-3xl bg-gradient-to-br from-gray-900 via-gray-900 to-gray-800 px-8 py-14 md:px-14 md:py-20 overflow-hidden">
          {/* Decorative gradient orb */}
          <div
            className="absolute top-0 right-0 w-[500px] h-[500px] bg-lavender-500/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"
            aria-hidden="true"
          />

          <div className="relative z-10">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-4">Need a custom solution?</h2>
              <p className="text-lg text-gray-400 max-w-2xl mx-auto leading-relaxed">
                For high-volume print shops and enterprise sellers processing hundreds of orders daily. Let us build a
                plan tailored to your operation.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
              {highlights.map(item => (
                <div key={item.title} className="text-center">
                  <div className="w-10 h-10 rounded-lg bg-lavender-500/10 flex items-center justify-center mx-auto mb-3">
                    <item.icon className="w-5 h-5 text-lavender-400" aria-hidden="true" />
                  </div>
                  <h3 className="text-sm font-semibold text-white mb-1">{item.title}</h3>
                  <p className="text-xs text-gray-400 leading-relaxed">{item.description}</p>
                </div>
              ))}
            </div>

            <div className="text-center">
              <a
                href="mailto:sales@craftflow.com?subject=Enterprise%20Inquiry"
                className="inline-flex items-center justify-center px-8 py-3.5 rounded-lg font-semibold text-sm bg-white text-gray-900 hover:bg-gray-100 transition-colors shadow-lg"
              >
                Talk to Sales
              </a>
              <p className="mt-3 text-xs text-gray-500">Typically responds within 24 hours</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EnterpriseCTASection;
